import BaseService from "../../../services/BaseService";
import axios from 'axios';

class JourneyProfileService extends BaseService{
	
	async getPortal(id){
		return axios.get(`${this.url}/portal/${id}`);
	}

};

export default new JourneyProfileService('health_backend', 'journey_profiles');